import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../services/auth';
import logo from '../assets/images/gifs/iceking-dance.gif';
import './LoginPage.css';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const login = useAuthStore((state) => state.login);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    //setIsLoading(true); // Add a loading state
    
    try {
      // First handle the regular login
      await login(username, password);
      
      // Then try Google authentication
      // try {
      //   //await useAuthStore.getState().authenticateGoogle();
      //   navigate('/');
      // } catch (googleError) {
      //   console.error('Google auth failed:', googleError);
      //   // You might still want to navigate even if Google auth fails
      //   // since the main login succeeded
      //   // navigate('/');
      // }
    } catch (loginError) {
      if (loginError?.message?.includes('Failed to fetch')) {
        setError('Hi😭😭😭 Your backend is dead');
      }
      else
        setError('Invalid username or password');
      //setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form main-pixel-container">
        <div className='login-form-title'>
            <img className='login-form-logo' src={logo} alt="logo" />
            <h2>Login</h2>
        </div>
        <div className='divider-horizontal'/>
        
        <div className='login-form-content'>
          {error && <div className="error-message">{error}</div>}
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button className='add-button' type="submit">
            <span>Login</span>
          </button>
        </div>
      </form>
    </div>
  );
};

export default LoginPage; 